"use strict";

var _interopRequireDefault = require("E:/zkdn_workspace/zhijiao/bjzyjy-mhwz/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.coursePlacedTop = exports.courseList = void 0;
exports.coursesList = coursesList;
exports.positionList = exports.newsList = exports.majorInfoWebGet = exports.majorInfoCourseWebList = exports.getWebReceptionList = exports.getRouterList = exports.getReceptionList = exports.getPortalCourseTypeCount = exports.getPeCourseById = exports.getCourseTypeCount = void 0;
exports.recommendList = recommendList;
exports.resourceUpload = exports.resourcePut = exports.resourceList = exports.resourceDelete = void 0;
exports.specialClassificationList = specialClassificationList;
exports.zyzykList = exports.webList = void 0;
var _api = _interopRequireDefault(require("_l/api.request"));
var _qs = _interopRequireDefault(require("qs"));
// 虚拟仿真课 分页查询
var resourceList = exports.resourceList = function resourceList(data) {
  return _api.default.request({
    url: '/peCourse/peCourseList',
    method: 'post',
    data: data
  });
};

// 虚拟仿真课 新增/编辑
var resourceUpload = exports.resourceUpload = function resourceUpload(data) {
  return _api.default.request({
    url: '/peCourse/insertOrUpdatePeCourse',
    method: 'post',
    data: data
  });
};

// 虚拟仿真课 删除
var resourceDelete = exports.resourceDelete = function resourceDelete(data) {
  return _api.default.request({
    url: '/peCourse/removePeCourse',
    method: 'post',
    data: data
  });
};

// 虚拟仿真课 上下架
var resourcePut = exports.resourcePut = function resourcePut(data) {
  return _api.default.request({
    url: '/peCourse/updateShowStatus',
    method: 'post',
    data: data
  });
};

// /peCourse/getReceptionList
// 查询全部
// export const getReceptionList = (data) => {
//   return axios.request({
//     url: '/peCourse/getReceptionList',
//     method: 'post',
//     data: data
//   })
// }
var getWebReceptionList = exports.getWebReceptionList = function getWebReceptionList(data) {
  return _api.default.request({
    url: '/system/web/peCourse/getWebReceptionList',
    method: 'post',
    data: data
  });
};
var courseList = exports.courseList = function courseList(data) {
  return _api.default.request({
    url: '/courseSource/getListAll',
    method: 'post',
    data: data
  });
};

//专业资源库APi
var webList = exports.webList = function webList(data) {
  return _api.default.request({
    url: '/major/info/web/list',
    method: 'post',
    data: data
  });
};
// /major/info/web/list

var getRouterList = exports.getRouterList = function getRouterList() {
  return _api.default.request({
    url: '/user/userInfo',
    method: 'post'
  });
};
var getCourseTypeCount = exports.getCourseTypeCount = function getCourseTypeCount(data) {
  return _api.default.request({
    url: '/peCourse/getCourseTypeCount',
    method: 'post',
    data: data
  });
};
var getPortalCourseTypeCount = exports.getPortalCourseTypeCount = function getPortalCourseTypeCount(data) {
  return _api.default.request({
    url: '/system/web/peCourse/getCourseTypeCount',
    method: 'post',
    data: data
  });
};

//置顶 /peCourse/coursePlacedTop?id=#{id}
var coursePlacedTop = exports.coursePlacedTop = function coursePlacedTop(data) {
  return _api.default.request({
    url: '/peCourse/coursePlacedTop' + jsonjoin(data),
    method: 'get',
    data: data
  });
};
//获取首页新闻公告
var newsList = exports.newsList = function newsList(data) {
  return _api.default.request({
    url: '/web/newsWebList',
    method: 'post',
    data: data
  });
};
function jsonjoin(data) {
  var str = '?';
  for (var key in data) {
    str += key + '=' + data[key] + '&';
  }
  return str.substring(0, str.length - 1);
}

// 分页查询（前台）
var getReceptionList = exports.getReceptionList = function getReceptionList(data) {
  return _api.default.request({
    url: '/system/web/peCourse/getReceptionList',
    method: 'post',
    data: data
  });
};
var getPeCourseById = exports.getPeCourseById = function getPeCourseById(data) {
  return _api.default.request({
    url: '/system/web/peCourse/getPeCourseById',
    method: 'post',
    data: data
  });
};

// 查询推荐课程信息列表
function recommendList(query) {
  return _api.default.request({
    url: '/system/web/recommend/list',
    method: 'get',
    params: query
  });
}

// 查询专题课程列表
function coursesList(query) {
  return _api.default.request({
    url: '/system/web/specialCoursesList',
    method: 'get',
    params: query
  });
}

// 查询专业资源库
var zyzykList = exports.zyzykList = function zyzykList(data) {
  return _api.default.request({
    url: '/system/major/info/web/list',
    method: 'post',
    data: data
  });
};

// 专业资源库详情（门户）
var majorInfoWebGet = exports.majorInfoWebGet = function majorInfoWebGet(data) {
  return _api.default.request({
    url: '/system/major/info/web/get',
    method: 'post',
    data: data
  });
};

// 专业资源库课程列表（门户）
var majorInfoCourseWebList = exports.majorInfoCourseWebList = function majorInfoCourseWebList(data) {
  return _api.default.request({
    url: '/system/major/info/course/web/list',
    method: 'post',
    data: data
  });
};
// // 精品课与视频公开课
// export const getReceptionList = (data) => {
//   return axios.request({
//     url: '/system/web/peCourse/getReceptionList',
//     method: 'post',
//     data,
//   })
// }
// 职位分类
var positionList = exports.positionList = function positionList(data) {
  return _api.default.request({
    url: '/system/web/positionList',
    method: 'get',
    data: data
  });
};

// 查询专题分类列表
function specialClassificationList(query) {
  return _api.default.request({
    url: '/system/web/specialClassificationList',
    method: 'get',
    params: query
  });
}